import * as React from 'react';
import { connect } from 'react-redux';

import { navigate } from 'libs/router';

import { t } from 'utils/language';

import Entity from 'components/entity/Entity';
import OrganizationEntityAvatar from 'components/entity/entity-avatar/OrganizationEntityAvatar';
import OrganizationEntityName from 'components/entity/entity-name/OrganizationEntityName';
import ActionButton from 'components/buttons/action-button/ActionButton';
import { Table, TableCell, TableContainer, TableRow } from 'components/table';
import { ModalFrame, ModalOpener } from 'components/modal';

import type { Organization } from 'types';

type StateProps = {
  organizationsList: Array<Organization>
};

type OwnProps = {
  next: 'campaigns' | 'profiles' | 'team'
};

type Props = StateProps & OwnProps;

export class SelectOrganizationModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    const { organizationsList, next } = props;

    if (!organizationsList.length) {
      navigate.to('/user/settings');
      return;
    }

    if (organizationsList.length === 1) {
      navigate.to(`/organizations/${organizationsList[0].id}/${next}`);
    }
  }

  render(): React.ReactNode {
    const { organizationsList, next } = this.props;

    return (
      <ModalOpener
        open
        width="small"
        showClose={false}
      >
        <ModalFrame
          title={t('select_organization_modal_title')}
        >
          <br />
          <TableContainer>
            <Table>
              {
                organizationsList.map((organization, index) => {
                  const link = next === 'team'
                    ? `/organizations/${organization.id}/settings/team-members`
                    : `/organizations/${organization.id}/${next}`;

                  return (
                    <TableRow
                      key={`organization-${organization.id}-${index}`}
                    >
                      <TableCell
                        width="fill"
                      >
                        <Entity>
                          <OrganizationEntityAvatar
                            organization={organization}
                            form="round"
                            size="big"
                            bordered
                          />
                          <OrganizationEntityName
                            organization={organization}
                          />
                        </Entity>
                      </TableCell>
                      <TableCell
                        align="right"
                      >
                        <ActionButton
                          width="minimum"
                          link={link}
                        >
                          {t('select_organization_button')}
                        </ActionButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              }
            </Table>
          </TableContainer>
        </ModalFrame>
      </ModalOpener>
    );
  }
}

const mapStateToProps = ({ organizations }): StateProps => ({
  organizationsList: organizations.list
});

export default connect(mapStateToProps)(SelectOrganizationModal);
